import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from './Adapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  get_UploadAdapter1jp2f4wtvjtde as get_UploadAdapter,
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_BooleanAdapterefxw889yjdy4 as get_BooleanAdapter,
  get_IntAdapter2kzerdn7hhunh as get_IntAdapter,
  get_DoubleAdapter3vjvxl0ttbawu as get_DoubleAdapter,
  get_LongAdapter1acs38m0a7icu as get_LongAdapter,
  get_FloatAdapter8hkphxq3v57l as get_FloatAdapter,
  get_AnyAdapterx2g0krnqn0y9 as get_AnyAdapter,
} from './Adapters.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from './ExecutionContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {
      constructor() {
        Key_instance = this;
        this.d48_1 = (new (Builder())()).e3a();
      }
    }
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  if (Key_instance === VOID)
    new (Key())();
  return Key_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp.e48_1 = LinkedHashMap().fc();
        this.f48_1 = null;
        this.g48_1 = null;
        this.h48_1 = null;
      }
      i48(customScalarAdapters) {
        // Inline function 'kotlin.apply' call
        this.e48_1.d5(customScalarAdapters.m48_1);
        return this;
      }
      y4() {
        this.e48_1.y4();
      }
      e3a() {
        return new (CustomScalarAdapters())(this.e48_1, this.f48_1, this.g48_1, this.h48_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder);
    BuilderClass = $;
  }
  return BuilderClass;
}
var CustomScalarAdaptersClass;
function CustomScalarAdapters() {
  if (CustomScalarAdaptersClass === VOID) {
    class $ {
      constructor(customScalarAdapters, falseVariables, deferredFragmentIdentifiers, errors) {
        Key_getInstance();
        this.j48_1 = falseVariables;
        this.k48_1 = deferredFragmentIdentifiers;
        this.l48_1 = errors;
        this.m48_1 = customScalarAdapters;
      }
      n48(customScalar) {
        var registered = this.m48_1.v4(customScalar.h46_1);
        if (!(registered == null)) {
          return isInterface(registered, Adapter()) ? registered : THROW_CCE();
        }
        var tmp;
        switch (customScalar.g46_1) {
          case 'com.apollographql.apollo.api.Upload':
            tmp = get_UploadAdapter();
            break;
          case 'kotlin.String':
          case 'java.lang.String':
            tmp = get_StringAdapter();
            break;
          case 'kotlin.Boolean':
          case 'java.lang.Boolean':
            tmp = get_BooleanAdapter();
            break;
          case 'kotlin.Int':
          case 'java.lang.Int':
            tmp = get_IntAdapter();
            break;
          case 'kotlin.Double':
          case 'java.lang.Double':
            tmp = get_DoubleAdapter();
            break;
          case 'kotlin.Long':
          case 'java.lang.Long':
            tmp = get_LongAdapter();
            break;
          case 'kotlin.Float':
          case 'java.lang.Float':
            tmp = get_FloatAdapter();
            break;
          case 'kotlin.Any':
          case 'java.lang.Object':
            tmp = get_AnyAdapter();
            break;
          default:
            // Inline function 'kotlin.error' call

            var message = "Can't map GraphQL type: `" + customScalar.h46_1 + '` to: `' + customScalar.g46_1 + '`. Did you forget to add a scalar Adapter?';
            throw IllegalStateException().o(toString(message));
        }
        var tmp_0 = tmp;
        return isInterface(tmp_0, Adapter()) ? tmp_0 : THROW_CCE();
      }
      m3() {
        return Key_getInstance();
      }
      o48(falseVariables, deferredFragmentIdentifiers, errors) {
        if (falseVariables == null && deferredFragmentIdentifiers == null && errors == null && this.j48_1 == null && this.k48_1 == null && this.l48_1 == null) {
          return this;
        }
        return new (CustomScalarAdapters())(this.m48_1, falseVariables, deferredFragmentIdentifiers, errors);
      }
    }
    protoOf($).p48 = get;
    protoOf($).q48 = fold;
    protoOf($).r48 = minusKey;
    protoOf($).t44 = plus;
    initMetadataForClass($, 'CustomScalarAdapters', VOID, VOID, [Element()]);
    CustomScalarAdaptersClass = $;
  }
  return CustomScalarAdaptersClass;
}
//region block: exports
export {
  Builder as Builder4ra56zvvku0a,
  Key_getInstance as Key_getInstance3kkpczi3zr320,
};
//endregion

//# sourceMappingURL=CustomScalarAdapters.mjs.map
